import React from 'react';
import { Badge } from '../components/ui/badge';
import { FileText } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden bg-gradient-to-b from-gray-900 to-gray-800">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-full h-full" style={{
            backgroundImage: `radial-gradient(circle at 25% 25%, #0066FF 1px, transparent 1px),
                             radial-gradient(circle at 75% 75%, #0066FF 1px, transparent 1px)`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        <div className="absolute top-10 right-10 w-32 md:w-64 h-32 md:h-64 bg-[#0066FF]/20 rounded-full blur-3xl" />
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <Badge className="bg-white/10 text-white hover:bg-white/20 border-0 mb-4">
            <FileText className="w-4 h-4 mr-2" />
            Legal
          </Badge>
          <h1 className="text-4xl sm:text-5xl font-bold mb-6 text-white">
            Terms of Service
          </h1>
          <p className="text-gray-300">Last updated: December 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
          <p className="text-gray-600 mb-6">
            By accessing and using HRMQore's services, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Description of Services</h2>
          <p className="text-gray-600 mb-6">
            HRMQore provides a comprehensive HR management platform including employee management, payroll processing, attendance tracking, recruitment, and related services. We reserve the right to modify or discontinue any feature at any time.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">3. User Accounts</h2>
          <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
            <li>You must provide accurate and complete information when creating an account</li>
            <li>You are responsible for maintaining the confidentiality of your credentials</li>
            <li>You must notify us immediately of any unauthorized use of your account</li>
            <li>We reserve the right to suspend or terminate accounts that violate these terms</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Acceptable Use</h2>
          <p className="text-gray-600 mb-4">You agree not to:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
            <li>Use the service for any unlawful purpose</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Interfere with or disrupt the service's functionality</li>
            <li>Upload malicious code or harmful content</li>
            <li>Share your account credentials with unauthorized parties</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Data Ownership</h2>
          <p className="text-gray-600 mb-6">
            You retain ownership of all data you input into HRMQore. We process your data solely to provide our services and as outlined in our Privacy Policy. You grant us a license to use, store, and process your data for service delivery purposes.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Payment Terms</h2>
          <p className="text-gray-600 mb-6">
            Subscription fees are billed in advance on a monthly or annual basis. All fees are non-refundable unless otherwise specified. We reserve the right to modify pricing with 30 days notice.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Limitation of Liability</h2>
          <p className="text-gray-600 mb-6">
            HRMQore shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service. Our total liability shall not exceed the amount paid by you in the twelve months preceding the claim.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Termination</h2>
          <p className="text-gray-600 mb-6">
            Either party may terminate this agreement at any time. Upon termination, your access to the service will be disabled, and we will retain your data for 30 days before permanent deletion unless legally required to retain it longer.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Contact Information</h2>
          <div className="bg-gray-50 p-6 rounded-lg">
            <p className="text-gray-700 font-semibold">HRMQore</p>
            <p className="text-gray-600">Email: legal@hrmqore.com</p>
            <p className="text-gray-600">Phone: 07042050336</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
